export enum DashboardTab {
    OVERVIEW = 'overview',
    GLOBAL_STATES = 'global_states',
    STATS = 'stats'
}
